import React, { createContext, ReactNode, useContext, useState } from "react";

type TitleAlign = "left" | "center";

interface TitleContextType {
  title: string;
  titleAlign: TitleAlign;
  setTitle: (title: string, align?: TitleAlign) => void;
}

const TitleContext = createContext<TitleContextType | undefined>(undefined);

interface TitleProviderProps {
  children: ReactNode;
}

export const TitleProvider = ({ children }: TitleProviderProps) => {
  const [title, setTitleValue] = useState("");
  const [titleAlign, setTitleAlign] = useState<TitleAlign>("left");

  const setTitle = (title: string, align: TitleAlign = "left") => {
    setTitleValue(title);
    setTitleAlign(align);
  };

  return <TitleContext.Provider value={{ title, titleAlign, setTitle }}>{children}</TitleContext.Provider>;
};

export const useTitle = (): TitleContextType => {
  const context = useContext(TitleContext);
  if (!context) {
    throw new Error("useTitle must be used within a TitleProvider");
  }
  return context;
};
